import { lazy } from 'react';

const Player = lazy(() => import('components/pages/Player/Player'));
const ResultItem = lazy(() => import('components/pages/ResultItem/ResultItem'));
const Go = lazy(() => import('components/pages/Go/Go'));
const ResultGuard = lazy(() => import('components/pages/Result/ResultGuard'));

export const routes = {
  player: {
    path: '/run/:env/:activitySessionId/:authenticated/:activityItemId?',
    component: Player,
    params: {
      env: ':env',
      activitySessionId: ':activitySessionId',
      authenticated: 'authenticated',
      activityItemId: ':activityItemId?',
    },
  },
  resultItem: {
    path: '/result/:env/:activitySessionId/:authenticated/:activityItemId',
    component: ResultItem,
    params: {
      env: ':env',
      activitySessionId: ':activitySessionId',
      authenticated: 'authenticated',
      activityItemId: ':activityItemId',
    },
  },
  result: {
    path: '/result/:env/:activitySessionId/:authenticated',
    component: ResultGuard,
    params: {
      env: ':env',
      activitySessionId: ':activitySessionId',
      authenticated: 'authenticated',
    },
  },
  home: {
    path: '/',
    component: Go,
    params: {},
  },
};

export const routesKeys = Object.keys(routes);
